// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3StWB","unreadBadge":"styles_unreadBadge__3ovdy","modalContent":"styles_modalContent__2aI6y","modal":"styles_modal__250GQ"};